import { useMutation as useMutationCore } from '@apollo/client';
import { Trans } from 'gatsby-plugin-react-i18next';
import useLanguage from 'hooks/useLanguage';
import React from 'react';
import { toast } from 'react-toastify';

const handleMutationError = ({ graphQLErrors, networkError }) => {
	if (graphQLErrors) {
		graphQLErrors.forEach(({ message, locations, path }) =>
			toast.error(<Trans i18nKey="message.error.graphql" values={{ message, locations, path }} />)
		);
	}
	if (networkError) {
		if(networkError.statusCode === 500) {
			toast.error(<Trans i18nKey="message.error.500" />);
		} else if(!networkError.result?.errors?.length) {
			toast.error(<Trans i18nKey="message.error.network" values={{ networkError }} />);
		} else {
		//	400 probably
		}
	}
};

export default function useMutation(form, options) {
	const { language } = useLanguage();

	const [sendForm, mutationRes] = useMutationCore(form, {
		context: {
			headers: {
				'Accept-Language': language,
			},
			...options.context,
		},
		onCompleted: data => {
			if(data[form.definitions[0].name.value]?.errors?.length) {
				let errors = {};

				data[form.definitions[0].name.value]?.errors.map(item => {
					Object.assign(errors,
						{ [item.field]: item.messages[0] }
					);
				});
				options.onErrors(errors);
				// if(isFunction(options.onErrors)) {
				// }
			} else {
				options.onSuccess(data);
				// if(isFunction(options.onSuccess)) {
				// }
			}
		},
		onError: error => {
			handleMutationError({
				graphQLErrors: error.graphQLErrors,
				networkError: error.networkError,
			});
			// if(isFunction(options.onError)) {
			// 	options.onError(error);
			// }
		}
	});

	return [
		sendForm,
		mutationRes
	];
}

useMutation.defaultProps = {
	options: {
		onSuccess: () => {},
		onErrors: () => {},
		onError: () => {}
	}
};
// // TODO: typescript
// useMutation.propTypes = {
// 	options: PropTypes.objectOf({
// 		onSuccess: PropTypes.func,
// 		onErrors: PropTypes.func,
// 		onError: PropTypes.func,
// 	})
// };
